<template>
  <b-container>
    <div v-if="permissions == 0">
      <h4>Você não possui acesso a esta ocorrência</h4>
    </div>
    <div v-else>
      <!-- cargoId -->
      <base-row-detail
        :label="`${$t('tracking.cargoExpense.model.cargo')} :`"
        :value="`${this.model.cargoId}`"
      ></base-row-detail>

      <!-- clientName -->
      <base-row-detail
        :label="`${$t('tracking.cargo.clientName')} :`"
        :value="this.model.clientName"
      ></base-row-detail>

      <!-- branchName -->
      <base-row-detail
        :label="`${$t('tracking.cargo.companyBranchName')} :`"
        :value="this.model.branchName"
      ></base-row-detail>

      <!-- driverName -->
      <base-row-detail
        :label="`${$t('tracking.cargo.driverName')} :`"
        :value="this.model.driverName"
      ></base-row-detail>

      <!-- transportNumber -->
      <base-row-detail
        :label="`${$t('tracking.cargo.transportNumber')} :`"
        :value="this.model.transportNumber"
      ></base-row-detail>

      <div class="mt-2">
        <!-- CargoExpenseTypeId -->
        <b-form-group
          :label="$t('tracking.cargoExpenseType.model.description')"
          label-for="cargoExpenseTypeId"
        >
          <!-- :currentPage.sync="tableCurrentPage" -->
          <cargo-expense-type-dropdown
            id="cargoExpenseTypeId"
            :value.sync="model.cargoExpenseTypeId"
            :readonly="getPermission"
          >
          </cargo-expense-type-dropdown>
          <span class="text-danger" v-if="modelstate['CargoExpenseTypeId']">
            {{ modelstate["CargoExpenseTypeId"][0] }}
          </span>
        </b-form-group>

        <!-- CargoExpenseOccurrence -->
        <b-form-group
          :label="$t('tracking.cargoExpense.model.currentOccurrence')"
          label-for="CargoExpenseOccurrenceId"
        >
          <cargo-expense-occurrence-dropdown
            id="CargoExpenseOccurrenceId"
            :value.sync="model.cargoExpenseOccurrenceId"
            :readonly="getPermission"
          >
          </cargo-expense-occurrence-dropdown>
          <span
            class="text-danger"
            v-if="modelstate['CargoExpenseOccurrenceId']"
          >
            {{ modelstate["CargoExpenseOccurrenceId"][0] }}
          </span>
        </b-form-group>

        <!-- Responsability -->
        <b-form-group
          :label="$t('tracking.cargoExpense.model.responsability')"
          label-for="responsability"
        >
          <cargo-expense-responsability-dropdown
            :value.sync="model.responsability"
            :placeholder="$t('tracking.cargoExpense.model.responsability')"
            :readonly="getPermission"
          >
          </cargo-expense-responsability-dropdown>
          <span class="text-danger" v-if="modelstate['Responsability']">
            {{ modelstate["Responsability"][0] }}
          </span>
        </b-form-group>

        <!-- Date -->
        <b-form-group
          :label="$t('tracking.cargoExpense.model.date')"
          label-for="date"
        >
          <base-input-date
            :value.sync="model.date"
            :placeholder="$t('tracking.cargoExpense.model.date')"
            :readonly="getPermission"
          >
          </base-input-date>
          <span class="text-danger" v-if="modelstate['Date']">
            {{ modelstate["Date"][0] }}
          </span>
        </b-form-group>
        <!-- <b-form-group
        :label="$t('tracking.cargoExpense.model.date')"
        label-for="date"
      >
        <b-form-input
          id="date"
          type="date"
          :placeholder="$t('tracking.cargoExpense.model.date')"
          v-model="model.date"
          :readonly="readonly"
        />
        <span class="text-danger" v-if="modelstate['Date']">
          {{ modelstate["Date"][0] }}
        </span>
      </b-form-group> -->

        <!-- Value -->
        <b-form-group
          :label="$t('tracking.cargoExpense.model.value')"
          label-for="value"
        >
          <base-input-numeric
            :value.sync="model.value"
            :placeholder="$t('tracking.cargoExpense.model.value')"
            :readonly="getPermission"
          >
          </base-input-numeric>
          <span class="text-danger" v-if="modelstate['Value']">
            {{ modelstate["Value"][0] }}
          </span>
        </b-form-group>

        <!-- AdicionalInformation -->
        <b-form-group
          :label="$t('tracking.cargoExpense.model.adicionalInformation')"
          label-for="adicionalInformation"
        >
          <b-form-textarea
            id="adicionalInformation"
            :placeholder="
              $t('tracking.cargoExpense.model.adicionalInformation')
            "
            v-model="model.adicionalInformation"
            :readonly="getPermission"
          />
          <span class="text-danger" v-if="modelstate['AdicionalInformation']">
            {{ modelstate["AdicionalInformation"][0] }}
          </span>
        </b-form-group>
        <base-attachments
          ref="attachments"
          :files-bytes="model.attachments"
          @change="addAttachment"
          :readonly="getPermission"
        >
        </base-attachments>
      </div>
    </div>
    <!-- <div>permissions: {{permissions}}</div> -->
    <!-- <div>{{getPermission}}</div> -->
    <!-- <div>{{ model }}</div> -->
    <!-- <div>{{customField}}</div> -->
    <!-- <div>model.weight: {{model.weight}}</div> -->
  </b-container>
</template>

<script>
import BaseAttachment from "@/components_rms/base/BaseAttachment.vue";
import BaseAttachments from "@/components_rms/base/BaseAttachments.vue";
import BaseInputDate from "@/components_rms/base/BaseInputDate.vue";
import BaseInputNumeric from "@/components_rms/base/BaseInputNumeric.vue";
import BaseRowDetail from "@/components_rms/base/BaseRowDetail.vue";
import CargoExpenseResponsabilityDropdown from "@/components_rms/trackingShippingCompany/cargoExpense/CargoExpenseResponsabilityDropdown.vue";
import CargoExpenseOccurrenceDropdown from "@/components_rms/trackingShippingCompany/cargoExpenseOccurrence/CargoExpenseOccurrenceDropdown.vue";
import CargoExpenseTypeDropdown from "@/components_rms/trackingShippingCompany/cargoExpense/CargoExpenseTypeDropdown.vue";

import BaseAttachmentItem from "@/components_rms/base/BaseAttachmentItem.vue";
export default {
  name: "CargoExpenseCrudData",
  directives: {},
  props: {
    model: Object,
    modelstate: Object,
    readonly: Boolean,
    cargoExpenseTypeId: Number,
    permissions: Number,
  },
  components: {
    BaseAttachment,
    BaseAttachments,
    BaseInputDate,
    BaseInputNumeric,
    BaseRowDetail,
    CargoExpenseResponsabilityDropdown,
    CargoExpenseOccurrenceDropdown,
    CargoExpenseTypeDropdown,
    BaseAttachmentItem,
  },
  data() {
    return {
      anexos: [],
      customFields: [],
      editField: false,
    };
  },
  created() {
    
  },
  mounted() {},
  computed: {
    getPermission() {
      if (this.permissions == 2) return true;
      return false;
    },
  },
  methods: {
    addAttachment(attachment) {
      console.log("addAttachment");
      this.model.attachments[0].attachment = attachment;
    },
    changeAttachment(attachment) {
      console.log("changeAttachment");
      this.model.attachment.attachment = attachment;
    },
    getDataAsOjbect() {
      
      this.model.attachments = this.$refs.attachments.getFilesAsBytes();
      // formData.append("cargo", this.model);

      // formData.append("adicionalInformation", this.model.adicionalInformation);
      // formData.append("branchName", this.model.branchName);
      // formData.append("cargoExpenseId", this.model.cargoExpenseId);
      // formData.append("cargoId", this.model.cargoId);
      // formData.append("cargoExpenseTypeId", this.model.cargoExpenseTypeId);
      // formData.append(
      //   "cargoExpenseTypeDescription",
      //   this.model.cargoExpenseTypeDescription
      // );
      // formData.append("clientName", this.model.clientName);
      // formData.append("driverName", this.model.driverName);
      // formData.append("date", this.model.date);
      // formData.append("value", this.model.value);
      // formData.append("responsability", this.model.responsability);
      // formData.append("priority", this.model.priority);

      return this.model;
    },
    getDataAsForm() {
      let formData = this.$refs.attachments.getFilesAsForm();
      // formData.append("cargo", this.model);

      // formData.append("adicionalInformation", this.model.adicionalInformation);
      // formData.append("branchName", this.model.branchName);
      // formData.append("cargoExpenseId", this.model.cargoExpenseId);
      // formData.append("cargoId", this.model.cargoId);
      // formData.append("cargoExpenseTypeId", this.model.cargoExpenseTypeId);
      // formData.append(
      //   "cargoExpenseTypeDescription",
      //   this.model.cargoExpenseTypeDescription
      // );
      // formData.append("clientName", this.model.clientName);
      // formData.append("driverName", this.model.driverName);
      // formData.append("date", this.model.date);
      // formData.append("value", this.model.value);
      // formData.append("responsability", this.model.responsability);
      // formData.append("priority", this.model.priority);

      return formData;
    },
  },
  watch: {
    model() {
      this.$forceUpdate();
    },
  },
};
</script>
